import type { FormInputType } from '@/components/UI/Form/types'

export default function getCertificationInstructionsFormInputs({
  firstName,
  lastName,
}: {
  firstName: string
  lastName: string
}): FormInputType[] {
  return [
    {
      type: 'multi-checkbox',
      name: 'acknowledge_instructions',
      label: 'Please acknowledge the instructions',
      options: [
        {
          value: 'verifyUser',
          label: `I confirm that I, ${firstName} ${lastName}, am the person completing this certification.`,
        },
        {
          value: 'browser',
          label: 'I am using the Google Chrome browser and not in an Incognito window.',
        },
        {
          value: 'headphones',
          label: 'I am not wearing headphones or earbuds.',
        },
        {
          value: 'electronics',
          label:
            'I am not using any electronics besides my computer/recording device, and I will not use a calculator unless explicitly allowed.',
        },
        {
          value: 'acceptedInstructions',
          label:
            'I will complete this certification based on the the instructions provided, and understand ' +
            'that attempting to get outside help during the exam would result in the flagging and possible ' +
            'suspension of my Schoolhouse account.',
        },
      ],
      required: true,
      size: 6,
    },
  ]
}
